// @flow @format

import type { Entities } from './redux/reducer/entities';
import * as L from 'partial.lenses';

type ProgresFile = {
  +version: '20190520',
  +progresses: Array<{ +contestUid: string, +courseUid: string, +progress: number }>,
};

export function convertProgressFile(progressFile: { [string]: number }, entities: Entities): ProgresFile {
  let allProgresses = [];

  for (const contestUid of Object.keys(progressFile)) {
    const contest = L.get(['contests', 'byId', contestUid], entities);
    if (!contest) continue;

    const progress = progressFile[contestUid];
    const progresses = contest.courses.map(courseUid => ({
      contestUid,
      courseUid,
      progress,
    }));

    allProgresses.push(...progresses);
  }

  return {
    version: '20190520',
    progresses: allProgresses,
  };
}
